import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { Card } from "reactstrap";
import { IconButton, LinearProgress, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";

import { useDispatch, useSelector } from "react-redux";
import { buyApi } from "../../app/slices/buySlice";
import { toast } from "react-toastify";
import NameDateSearchComponent from "../../components/customTable/NameDateSearchComponent";

export default function Buy() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const columnHelper = createMRTColumnHelper();
  const sliceResponse = useSelector((state) => state.buySlice.buy.data);
  const stateLoading = useSelector((state) => state.buySlice.loading);
  // console.log("stateLoading: in BUY", stateLoading);
  // const [loading, setLoading] = useState(true);

  const [showData, setShowData] = useState([]);

  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((originalData) => ({
        id: originalData._id,
        customerRefNo: originalData.customerRefNo || "N/A",
        statusCode: originalData.statusCode || "N/A",
        message: originalData.message || "N/A",
        quantity: originalData.result?.data?.quantity || "N/A",
        totalAmount: originalData.result?.data?.totalAmount || "N/A",
        preTaxAmount: originalData.result?.data?.preTaxAmount || "N/A",
        metalType: originalData.result?.data?.metalType || "N/A",
        rate: originalData.result?.data?.rate || "N/A",
        uniqueId: originalData.result?.data?.uniqueId || "N/A",
        transactionId: originalData.result?.data?.transactionId || "N/A",
        userName: originalData.result?.data?.userName || "N/A",
        merchantTransactionId:
          originalData?.result?.data?.merchantTransactionId || "N/A",
        mobileNumber: originalData.result?.data?.mobileNumber || "N/A",
        goldBalance: originalData.result?.data?.goldBalance || "N/A",
        silverBalance: originalData.result?.data?.silverBalance || "N/A",
        totalTaxAmount:
          originalData.result?.data?.taxes?.totalTaxAmount || "N/A",
        // taxSplit: originalData.result?.data?.taxes?.taxSplit || [],
        invoiceNumber: originalData.result?.data?.invoiceNumber || "N/A",
        referenceType: originalData.result?.data?.referenceType || "N/A",
        referenceId: originalData.result?.data?.referenceId || "N/A",
        partnerId: originalData.partner_id || "N/A",
        partnerUsername: originalData.partnerUsername || "N/A",
        createdAt: originalData.createdAt,
        updatedAt: originalData.updatedAt,
      }));
      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    // {
    //   accessorKey: 'customerRefNo',
    //   header: 'customerRefNo',
    //   enableClickToCopy: true,
    //   muiCopyButtonProps: {
    //     fullWidth: true,
    //     startIcon: <ContentCopy />,
    //     sx: { justifyContent: 'flex-start' },
    //   },
    // },
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: (cell) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("userName", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),
    columnHelper.accessor("rate", {
      header: "Rate",
      size: 30,
    }),
    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 30,
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 50,
    }),

    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile No",
      size: 30,
    }),
    columnHelper.accessor("goldBalance", {
      header: "Gold Balance",
      size: 30,
    }),
    columnHelper.accessor("silverBalance", {
      header: "Silver Balance",
      size: 30,
    }),
    columnHelper.accessor("totalTaxAmount", {
      header: "Total Tax Amount",
      size: 30,
    }),

    columnHelper.accessor("invoiceNumber", {
      header: "Invoice Number",
      size: 30,
    }),

    columnHelper.accessor("referenceId", {
      header: "Reference ID",
      size: 30,
    }),
    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.partnerId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  const dispatch = useDispatch();

  // Local state to manage search terms
  // const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchAadharData = useCallback(() => {
    // setLoading(true);

    let params = {};
    // if (searchTerm) {
    params.name = queryParams.customerName;
    // } else if (queryParams.startDate && queryParams.endDate) {
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    // }

    if (Object.keys(params).length > 0) {
      dispatch(buyApi(params)); // Dispatch API call even when reset (empty search term or date)
    }

    // setLoading(false);
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchAadharData();
  }, [fetchAadharData]);

  // Function to handle date search
  const handleSearchByDate = (startDate, endDate, customerName) => {
    // setLoading(true);

    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <>
      {/*  */}
      <Box>
        <Box>
          <Box
            mt={{ xs: 2 }}
            mb={2}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <NameDateSearchComponent onSearch={handleSearchByDate} />
          </Box>
        </Box>
        <Box sx={{ margin: "auto" }}>
          <CustomTable
            columns={columns}
            data={showData}
            loading={stateLoading}
            permissionKey="fintsoTransactions"
          />
        </Box>
      </Box>
    </>
  );
}
